import React, { useMemo } from 'react';
import merge from 'lodash.merge';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { sqlDateToLabel } from 'helpers/helpers'; //formatAmountValue
import { useTranslation } from 'react-i18next';
import { EdwardColors, Currency } from 'enums';

const xAxisLabelFormatter = function (this: Highcharts.AxisLabelsFormatterContextObject<number>) {
  const value = `${this.value}`;
  return sqlDateToLabel(value, 'dd.MM.yyyy');
  //return value;
};

interface ValueData {
  value: { value: number };
  date: string;
}

interface Props {
  data: ValueData[];
  settings?: Highcharts.Options;
  callback?: Highcharts.ChartCallbackFunction;
  currency: Currency;
}

const AssetGraph: React.FC<Props> = ({ data, currency, settings, callback }) => {
  const {
    i18n: { language },
    //t,
  } = useTranslation();

  const chartData = useMemo(() => data.map((dp: ValueData, i) => [dp.date, dp.value.value]), [data]);

  //console.log(chartData.length, chartData.length ? chartData[0] : '');

  const getTooltip = (tooltipData: Highcharts.TooltipFormatterContextObject): string => {
    if (!tooltipData.points) {
      return '';
    }

    const header = `<div style="text-align: center; margin-bottom: 5px;">
      <strong>
      ${sqlDateToLabel(tooltipData.points[0].key as unknown as string, 'dd. MM. yyyy')}
        </strong>
      </div>`;

    const rows = tooltipData.points
      .map(
        (point) =>
          `<tr>
          <td><span style="color: ${point.color}" class="_dot">\u25CF</span></td>
          <td>${Number((point.y as number).toFixed()).toLocaleString(language)} ${currency}</td>
        </tr>`,
      )
      .join('');

    return `${header}<table>${rows}</table>`;
  };

  const seriesData =
    [{
      showInLegend:false,
      data: chartData,
      color: EdwardColors.SECONDARY,

    }]
  ;

  const defaultSettings: Highcharts.Options = {
    title: { text: `` },
    credits: {
      enabled: false,
    },
    chart: {
      type: 'area',
      spacingTop: 20,
      spacingLeft: 40,
      spacingRight: 40,
      height: 300,
      backgroundColor: '#f5f5f5'
    },
    xAxis: {
      labels: {
        enabled: true,
        formatter: xAxisLabelFormatter,
        overflow: 'allow',
        style: { color: '#000' }
      },
      type: 'category',
      //tickInterval: Math.floor(chartData.length / 6),
      //tickAmount: 6
      //minTickInterval: 10

    },
    yAxis: {
      title: {
        text: '',
      },
      labels: {
        enabled: true,
        formatter: function (this: Highcharts.AxisLabelsFormatterContextObject<number>) {
          return `${this.value.toLocaleString(language)} ${currency}`;
        },
        style: { color: '#000' }
      },
    },
    tooltip: {
      useHTML: true,
      outside: false,
      shared: true,
      className: '_tooltip',

      formatter: function () {
        let text = '';
        text += getTooltip(this);
        return text;
      },
    },
    plotOptions: {
      area: {
        lineWidth: 2.5,
        fillOpacity: 0,
        marker: {
          symbol: 'circle',
          radius: 8,
          enabled: false,
        },
      },
      series: { turboThreshold: 2000 }
    },
    series: seriesData as any,
  };
  /*
  Highcharts.setOptions({
    lang: {
      numericSymbols: [' tis.', ' mil.', ' mld.'],
    },
  });
  */
  const graphSettings = settings ? merge({}, defaultSettings, settings) : defaultSettings;

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={graphSettings}
      callback={callback}
    />
  );
};

export default React.memo(AssetGraph);
